module.exports = __webpack_public_path__ + "favicon.png?fb7928756aafa4e1e0e5927bad1be417";


//////////////////
// WEBPACK FOOTER
// ./client/static/favicon.png
// module id = 274
// module chunks = 0